import React from 'react'
import ProgressUI from '../../widgets/output/ProgressUI'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import EmptyListUI from '../../widgets/output/EmptyListUI'
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import LabelAndValueUI from '../../widgets/layout/LabelAndValueUI'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import OrderHeaderUI from '../../components/finapp/order/OrderHeaderUI'
import OrderItemListUI from '../../components/finapp/order/OrderItemListUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import OrderItemCreateModalSF from '../../components/finapp/order/OrderItemCreateModalSF'
import OrderItemUpdateModalSF from '../../components/finapp/order/OrderItemUpdateModalSF'
import './OrderItemListPage.css'

const OrderItemListPageUI = ({context, messageList, errorList, order, itemList, filteredItemList,
    statusList, searchFilter, onRefreshClick, onStatusFilterChange, onSearchFilterChange,
    updateOrderMode, onUpdateOrderClick, onCancelUpdateOrder, onUpdateOrderComplete,
    createOrderItemMode, onCreateOrderItemClick, onCreateOrderItemComplete, onCancelCreateOrderItem,
    updateOrderItemMode, onUpdateOrderItemClick, onUpdateOrderItemComplete, onCancelUpdateOrderItem, updateOrderItem
  }) =>
  <PrivatePageSF context={context} className='pg_ord_items' backLink='/orders'
    messageList={messageList} headerMessageKey='c_cust_order'
    centered={(!order || !itemList) && !errorList}
  >
    {
      (!order || !itemList || !statusList) && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      order && itemList &&
      <React.Fragment>
        <PageTitleUI context={context} goBack={true} backLink='/orders'
          messageList={messageList} titleMessageKey='c_cust_order'
        />
        <OrderHeaderUI context={context} messageList={messageList}
          order={order} onUpdateClick={onUpdateOrderClick}
          updateMode={updateOrderMode} onCancelClick={onCancelUpdateOrder}
          onUpdateComplete={onUpdateOrderComplete}
        />
        <ItemListHeaderUI context={context} messageList={messageList} order={order}
          updateOrderMode={updateOrderMode}
        />
      </React.Fragment>
    }
    {
      itemList && itemList.length === 0 && statusList &&
      <EmptyListUI
        context={context}
        messageList={messageList}
        createEnabled={context.permissions && context.permissions.includes('acc_manage')}
        onCreateClick={onCreateOrderItemClick}
        createLinkKey='c_add_ord_item'
        createDisabledMessageKey='c_no_item_msg'
      />
    }
    {
      order && itemList && filteredItemList && itemList.length !== 0 && statusList &&
      <OrderItemListUI
        context={context}
        order={order}
        itemList={filteredItemList}
        messageList={messageList}
        statusList={statusList}
        searchFilter={searchFilter}
        // events
        onRefreshClick={onRefreshClick}
        onStatusFilterChange={onStatusFilterChange}
        onSearchFilterChange={onSearchFilterChange}
        onCreateClick={onCreateOrderItemClick}
        onUpdateClick={onUpdateOrderItemClick}
      />
    }
    <OrderItemCreateModalSF context={context} createMode={createOrderItemMode}
      onCancelClick={onCancelCreateOrderItem} onCreateComplete={onCreateOrderItemComplete}
    />
    <OrderItemUpdateModalSF context={context} updateMode={updateOrderItemMode}
      onCancelClick={onCancelUpdateOrderItem} onUpdateComplete={onUpdateOrderItemComplete}
      orderItem={updateOrderItem}
    />
  </PrivatePageSF>

const ItemListHeaderUI = ({context, messageList, order, updateOrderMode,
    onUpdateOrderClick, onUpdateOrderComplete}) =>
  <React.Fragment>
    <div className='g_flex_h g_m_top_50'>
      <ProgressUI messageList={messageList} labelKey='c_completion' percent={order.itemsDonePercent}/>
      <LabelAndValueUI messageList={messageList} labelKey='c_order_total' align='right'>
        {order.orderTotalF2}
      </LabelAndValueUI>
    </div>
  </React.Fragment>

export default OrderItemListPageUI
